<template>
	<div>
		<p :class="classes" :style="{ fontSize: fontSize + 'px' }">
			{{formattedString}}
			<span v-show="text.length > maxChars">
				<v-chip x-small id="readmore" v-show="!isReadMore" v-on:click.stop="triggerReadMore($event, true)">
					{{moreStr}}
				</v-chip>
				<v-chip x-small id="readmore" v-show="isReadMore" v-on:click.stop="triggerReadMore($event, false)">
					{{lessStr}}
				</v-chip>
			</span>
		</p>
	</div>
</template>

<script>
	import i18n from '@/plugins/i18n';
	export default{
		name: 'ReadMore',
		props: {
			fontSize: {
				type: Number,
				default: 22
			},
			moreStr: {
				type: String,
				default: i18n.t('inspections.labels.readMore')
			},
			lessStr: {
				type: String,
				default: i18n.t('inspections.labels.readLess')
			},
			text: {
				type: String,
				required: true
			},
			link: {
				type: String,
				default: '#'
			},
			maxChars: {
				type: Number,
				default: 100
			},
      classes: {
        type: String
      },
		},

		data () {
			return {
				isReadMore: false
			}
		},

		computed: {
			formattedString(){
				let val_container = this.text;

				if(!this.isReadMore && this.text.length > this.maxChars){
					val_container = val_container.substring(0,this.maxChars) + '...';
				}

				return(val_container);
			}
		},

		methods: {
			triggerReadMore(e, b){
				if(this.link == '#'){
					e.preventDefault();
				}
				if(this.lessStr !== null || this.lessStr !== '')
					this.isReadMore = b;
			}
		}
	}
</script>